import { observer } from 'mobx-react';
import { mobxInjectSelect } from '../../../../common/utils';
import BEM from '../../../../common/bem';
import { ReactComponent as ClockIconSvg } from '../../images/clock-icon.svg';

const classes = BEM.with('PEBanner');

type PEBannerProps = {
  peBanner: string;
};

const PEBannerComponent: React.FC<PEBannerProps> = ({ peBanner }) => {
  if (!peBanner?.length) return null;
  return (
    <div className={classes()} data-test-id="pe-banner">
      <span aria-hidden />
      <ClockIconSvg aria-hidden />
      <p>{peBanner}</p>
    </div>
  );
};

export const PEBanner = mobxInjectSelect<{}, PEBannerProps>({
  messengerStore: ['peBanner'],
})(observer(PEBannerComponent));
